import React,{useContext} from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';
import landing_3 from '../../assets/landing_3.jpg';
import './Experience.css';

import { experienceData } from '../../data/experienceData'
import ExperienceCard from './ExperienceCard';



function Experience(props) {

    const { theme } = useContext(ThemeContext);
    return (
        <div className="experience" id="experience" style={{backgroundColor: theme.secondary}}> 
             <div className="experience-body">
                 <div className="experience-image">
                    <img src={theme.expimg} alt="" />
                 </div>
				
                 <div className="experience-description">
                    <h1 style={{color:theme.primary}}>Experiences</h1>
                    <div className="experience-grid">
                    {props.experiences.map((exp, index) => (
                        <div className={`experience-card-container ${index % 2 === 0 ? 'left' : 'right'}`} key={exp.id}>
                            <ExperienceCard 
                                key={exp.id}
                                id={exp.id}
                                jobtitle={exp.Titre}
                                company={exp.CourteDescription}
                                startYear={exp.startYear}
                                endYear={exp.endYear}
								fullDescription={exp.Description}
                                image={exp.image}
                            />
                        </div>
                    ))}
                </div>
                 </div>
             </div>
        </div>
    )
}

export default Experience
